module.exports = __webpack_public_path__ + "static/media/ic_AI_text@2x.81e5104b.png";